import { ElationIntegrationComponent } from './Integrations/components/IntegrationComponents/ElationIntegrationComponent'
import { GoogleDriveIntegrationComponent } from './Integrations/components/IntegrationComponents/GoogleDriveIntegrationComponent'
import { GoogleSheetsIntegrationComponent } from './Integrations/components/IntegrationComponents/GoogleSheetsIntegrationComponent'
import { StripeIntegrationComponent } from './Integrations/components/IntegrationComponents/StripeIntegrationComponent'

export const IntegrationsTab = () => (
  <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
    <StripeIntegrationComponent />
    <GoogleDriveIntegrationComponent />
    <GoogleSheetsIntegrationComponent />
    <ElationIntegrationComponent />
  </div>
)
